import React from 'react';
import {useTranslation} from 'react-i18next';
import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {Link} from 'react-router-dom';
import {IPresentation} from '../../../../incase-domain/presentation';
import {IPaginatedResult} from '../../../../incase-domain/search';
import {fetchPresentationFeed} from '../../../../service/presentation';
import LoadingSpinnerComponent from '../../LoadingSpinnerComponent';
import FeedList from './components/FeedList';

const PAGE_NUM = 1 as const;
const PAGE_SIZE = 4 as const;

function PresentationFeed(): JSX.Element {
    const {t} = useTranslation();

    const presentationsFeed: UseQueryResult<IPaginatedResult<IPresentation>> = useQuery<IPaginatedResult<IPresentation>>(
        ['presentationsFeedList', PAGE_NUM, PAGE_SIZE],
        () => fetchPresentationFeed({pageNumber: PAGE_NUM, pageSize: PAGE_SIZE}),
        {keepPreviousData: true, refetchOnWindowFocus: false, refetchOnMount: false, staleTime: 5 * 60 * 1000}
    );

    return !presentationsFeed.isLoading ? (
        <>
            {presentationsFeed.data && presentationsFeed.data?.content.length > 0 && (
                <div className="u-pt-1">
                    <div className="u-flex u-h-between">
                        <div className="p-home__title--small">{t('homePage.feedTitle')}</div>
                        <Link to="/feed" className="e-link">
                            {t('common.seeAll')}
                        </Link>
                    </div>

                    <div className="u-pt-1">
                        <FeedList presentationFeed={presentationsFeed.data} />
                    </div>
                </div>
            )}
        </>
    ) : (
        <LoadingSpinnerComponent />
    );
}

export default PresentationFeed;
